import { ClientOnly } from "@tanstack/react-router"
import type { StripeElementsOptions } from "@stripe/stripe-js"
import { type ReactNode, Suspense, lazy } from "react"
import { Skeleton } from "@holigral/shared/ui/components/ui/skeleton"

// Stripe Elements touches window/DOM, so it is split into its own chunk and
// rendered behind ClientOnly — the SSR/prerender pass never loads it. Same
// pattern as FormMarkdownEditor.
const ElementsInner = lazy(() => import("./ElementsInner"))

type Props = {
  readonly options: StripeElementsOptions
  readonly children: ReactNode
}

export default function StripeElementsProvider({ options, children }: Props) {
  const fallback = <Skeleton className="h-48 w-full rounded-md" />

  return (
    <ClientOnly fallback={fallback}>
      <Suspense fallback={fallback}>
        <ElementsInner options={options}>{children}</ElementsInner>
      </Suspense>
    </ClientOnly>
  )
}
